import { createFileRoute } from "@tanstack/react-router";
import { buildHref } from "@softmax/web-addresses";
import { getPolicy } from "@/features/policies/records";
import { PolicyContent } from "@/features/policies";
import { NavigationReady } from "@softmax/web-features/navigation/markers";
import { PolicyPending } from "@/features/policies/navigation";
import { VerifiedViewer } from "@/session/product-session";

export const Route = createFileRoute(
  "/_site/policies/versions/$policyVersionId",
)({
  loader: ({ params, location, abortController }) =>
    getPolicy({
      signal: abortController.signal,
      data: {
        identifier: params.policyVersionId,
        kind: "version",
        search: location.searchStr,
      },
    }),
  component: PolicyVersionPage,
});

function PolicyVersionPage() {
  const { policyVersionId } = Route.useParams();
  const policy = Route.useLoaderData();

  const content = (
    <>
      <NavigationReady
        stage="content"
        path={buildHref({ name: "policyVersion", policyVersionId })}
      />
      <PolicyContent key={policy.selectedVersion.id} policy={policy} />
    </>
  );

  return policy.viewer ? (
    <VerifiedViewer viewer={policy.viewer} fallback={<PolicyPending />}>
      {content}
    </VerifiedViewer>
  ) : (
    content
  );
}
